<template>
  <div class="change-live2d">
    <div class="opt">
      <!--备注：这里上下左右方向相反-->
      <el-button type="primary" size="small" @click="updatePosition('down')">上</el-button>
      <el-button type="primary" size="small" @click="updatePosition('up')">下</el-button>
      <el-button type="primary" size="small" @click="updatePosition('right')">左</el-button>
      <el-button type="primary" size="small" @click="updatePosition('left')">右</el-button>
      <el-button type="primary" size="small" @click="updatePosition('save')">保存</el-button>
    </div>
    <div class="position">当前坐标: x: {{ position.x }}, y: {{ position.y }}</div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
import {debounce} from "@/plugins/util";

export default {
  data() {
    return {
      position: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    updatePosition: debounce(function (type) {
      eventBus.$emit('onPosition', type)
    }, 100),
  },
  mounted() {
    eventBus.$on('updatePosition', (position) => {
      this.position = position
    })
  }
}
</script>

<style scoped lang="less">
.change-live2d {
  position: absolute;
  top: 60px;
  left: 10px;
  z-index: 1000;

  .opt {
    margin-bottom: 10px;
    display: flex;
    column-gap: 10px;
  }
}
</style>
